<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('stockIn.pageTitle') }}</h1>
      <ts-breadcrumb :items="[
        { text: $t('home'), href: '/' },
        {
          text: $t('stockIn.pageTitle'),
          active: true
        }
      ]" />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-items-center ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">
              {{ $t('add_new') }}
            </ts-button>
            <a-range-picker v-model="dateRange" :allowClear="false" format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"
              class="ts-w-64" @change="fetchData()" />
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <Tooltip :content="$t('stockIn.search')" placement="top" transfer :max-width="width">
              <Input search v-model="search" :placeholder="$t('stockIn.search')" :style="width"
                @on-focus="() => (width = 'width: 500px')" @on-blur="() => (width = 'width: 300px')" />
            </Tooltip>
            <ts-filter ref="filter">
              <div class="row">
                <div class="col-md-12">
                  <label class="">{{ $t('employeeProfile.branch') }}</label>
                  <ts-branch-filter-v2 @filter="branchFilter" class="ts-w-full"></ts-branch-filter-v2>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-md-12">
                  <label class="">{{ $t('purchaseOrder.warehourse') }}</label>
                  <ts-location-filter @filter="filterLocaton"></ts-location-filter>
                </div>
              </div>
              <div class="row ts-mt-4">
                <div class="col-md-12">
                  <label>{{ $t('purchaseOrder.vendor') }}</label>
                  <a-select show-search mode="multiple" :placeholder="$t('all')" v-model="vendor_id" showSearch
                    :filterOption="(input, option) =>
                      option.componentOptions.children[0].text
                        .toLowerCase()
                        .indexOf(input.toLowerCase()) >= 0
                      " :options="suppliers" class="ts-w-full"></a-select>
                </div>
              </div>
            </ts-filter>
          </div>
        </div>
      </ts-card-wrapper>
      <Table :columns="columns" :data="resources" size="small" :loading="loading" highlight-row stripe
        max-height="700">
        <template slot-scope="{ row }" slot="branch">
          {{ row.branch ? row.branch.branch_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="po_number">
          {{ row.purchase_order ? row.purchase_order.po_number : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="amount">
          <ts-display-currency :amount="row.invoice_amount" :currency_id="row.currency_id" />
        </template>
        <template slot-scope="{ row }" slot="amount_paid">
          <ts-display-currency :amount="row.amount_paid" :currency_id="row.currency_id" />
        </template>
        <template slot-scope="{ row }" slot="amount_due">
          <ts-display-currency :amount="row.amount_due" :currency_id="row.currency_id" />
        </template>
        <template slot-scope="{ row }" slot="payment_status">
          <span class="badge badge-success" v-if="row.is_paid && row.amount_due == 0">Paid</span>
          <span class="badge badge-warning" v-else-if="!row.is_paid && row.amount_paid > 0">Partial</span>
          <span class="badge badge-danger" v-else>Due</span>
        </template>
        <template slot-scope="{ row }" slot="supplier">
          {{ row.supplier ? row.supplier.vendor_name : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="warehouse">
          {{ row.location ? row.location.location_name_en : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="confirm_stock">
          <span class="badge badge-success" v-if="row.is_confirm_stock">Yes</span>
          <span class="badge badge-danger" v-else>No</span>
        </template>
        <template slot-scope="{ row }" slot="confirmed_date">
          {{ row.confirmed_date ? row.confirmed_date : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="comfirmed_by">
          {{ row.comfirmed_by ? row.comfirmed_by.name : 'N/A' }}
        </template>
        <template slot-scope="{ row }" slot="action">
          <a href="#" v-tooltip="$t('pdf')" class="text-red mr-2" @click.prevent="previewPdf(row)">
            <i class="fas fa-file-pdf"></i>
          </a>
          <a v-if="!row.is_confirm_stock" href="#" v-tooltip="$t('edit')" class="text-primary mr-2"
            @click.prevent="edit(row)">
            <i class="fas fa-edit"></i>
          </a>
          <a-popconfirm v-if="!row.is_confirm_stock" placement="leftTop" v-tooltip="$t('delete')"
            :title="$t('are_you_sure_to_delete')" :ok-text="$t('yes')" :cancel-text="$t('no')"
            @confirm="deleteRecord(row)">
            <a href="#" :disabled="row._deleting">
              <i class="fas fa-circle-notch spin" v-if="row._deleting"></i>
              <i class="fa fa-trash text-red" v-else></i>
            </a>
          </a-popconfirm>
        </template>
      </Table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination v-model="pagination" @navigate="fetchData">
        </ts-pagination>
      </div>
    </ts-card>
    <a-modal :title="$t('pdf')" width="50%" v-model="show_pdf" :footer="null">
      <ts-preview-pdf v-model="waiting" :src="src" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapState } from 'vuex'
import expandRow from './table-expand.vue'

export default {
  name: 'stockIn',
  data() {
    return {
      loading: false,
      waiting: false,
      src: null,
      show_pdf: false,
      width: 'width: 300px',
      vendor: []
    }
  },
  computed: {
    ...mapState('stock/stockInV2', ['resources', 'pagination', 'formViewDatas']),
    search: {
      get() {
        return this.$store.state.stock.stockInV2.search
      },
      set(newValue) {
        this.$store.commit('stock/stockInV2/SET_SEARCH', newValue)
        this.$store.commit('stock/stockInV2/RESET_CURRENT_PAGE')
      }
    },
    inactive: {
      get() {
        return this.$store.state.stock.stockInV2.isInActive
      },
      set(newValue) {
        this.$store.commit('stock/stockInV2/SET_IS_INACTIVE', newValue)
      }
    },
    dateRange: {
      get() {
        return this.$store.state.stock.stockInV2.dateRange
      },
      set(newValue) {
        this.$store.commit('stock/stockInV2/SET_DATE_RANGE', newValue)
      }
    },
    vendor_id: {
      get() {
        return this.$store.state.stock.stockInV2.vendor_id
      },
      set(newValue) {
        this.$store.commit('stock/stockInV2/SET_VENDOR_ID', newValue)
      }
    },
    suppliers() {
      if (this.formViewDatas['suppliers']) {
        return this.formViewDatas['suppliers'].map(el => ({
          value: el.vendor_id,
          label: el.vendor_name,
          credit_day: el.credit_day,
          credit_amount: el.credit_amount
        }))
      }
      return []
    },
    default_precision() {
      return this.$store.state.authUser.sys_setting.decimal_digit
    },
    columns() {
      return [
        {
          type: 'expand',
          render: (h, params) => {
            return h(expandRow, {
              props: {
                row: params.row
              }
            })
          },
          width: 30
        },
        {
          title: this.$t('stockIn.stockInDate'),
          key: 'stock_in_date',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('stockIn.branch'),
          slot: 'branch',
          minWidth: 120,
          sortable: true
        },
        {
          title: this.$t('stockIn.stockInNumber'),
          key: 'stock_in_number',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('stockIn.poNumber'),
          slot: 'po_number',
          minWidth: 150,
          sortable: true
        },
        {
          title: this.$t('stockIn.invoiceNumber'),
          key: 'invoice_no',
          minWidth: 160,
          sortable: true
        },
        {
          title: this.$t('stockIn.amount'),
          slot: 'amount',
          minWidth: 140,
          align: 'right',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.amountPaid'),
          slot: 'amount_paid',
          minWidth: 140,
          align: 'right',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.amountDue'),
          slot: 'amount_due',
          minWidth: 140,
          align: 'right',
          sortable: true,
          tooltip: true
        },
        {
          title: this.$t('stockIn.paymentStatus'),
          slot: 'payment_status',
          minWidth: 150,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('stockIn.supplier/vendor'),
          slot: 'supplier',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('stockIn.warehouse'),
          slot: 'warehouse',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('stockIn.confirmStock'),
          slot: 'confirm_stock',
          minWidth: 140,
          align: 'center',
          sortable: true
        },
        {
          title: this.$t('stockIn.confirmDate'),
          slot: 'confirmed_date',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('stockIn.confirmBy'),
          slot: 'comfirmed_by',
          minWidth: 140,
          sortable: true
        },
        {
          title: this.$t('stockIn.remark'),
          key: 'description',
          minWidth: 200,
          sortable: true
        },
        {
          title: this.$t('actions'),
          key: 'action',
          slot: 'action',
          fixed: 'right',
          align: 'center',
          minWidth: 120
        }
      ]
    }
  },
  methods: {
    ...mapActions('stock/stockInV2', ['getFormViewModel']),
    async getPreData() {
      this.getFormViewModel({
        index: undefined,
        params: {
          fnName: 'suppliers'
        }
      }).catch(error => {
        this.notice({ type: 'error', text: error.message })
      })
    },
    addNew() {
      this.$router.push({ name: 'stock-in-create-v2' })
    },
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('stock/stockInV2/fetch', { ...attributes })
        .then(response => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    edit(row) {
      this.$store.commit('stock/stockInV2/SET_EDIT_DATA', row)
      this.$router.push({
        name: 'stock-in-edit-v2',
        params: { id: row.stock_in_id }
      })
    },
    deleteRecord(row) {
      row._deleting = true
      this.$store
        .dispatch('stock/stockInV2/destroy', row.stock_in_id)
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          row._deleting = false
        })
    },
    previewPdf(row) {
      this.show_pdf = true
      this.waiting = true
      this.src = ''
      this.$store
        .dispatch('stock/stockInV2/toPdf', row.stock_in_id)
        .then(response => {
          this.src = response.url
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.waiting = false
        })
    },
    getVendor() {
      this.vendor = []
      this.$store.dispatch('stock/stockIn/getVendor').then(response => {
        this.vendor = response.data.map(el => ({
          value: el.vendor_id,
          label: el.vendor_name
        }))
      })
    },
    branchFilter(value) {
      this.$store.commit('stock/stockInV2/SET_BRANCH_ID', value)
      this.fetchData()
    },
    filterLocaton(value) {
      this.$store.commit('stock/stockInV2/SET_LOCATION_ID', value)
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function () {
      this.fetchData()
    }, 500),
    vendor_id: debounce(function () {
      this.fetchData()
    }, 500)
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
      vm.getPreData()
    })
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('stock/stockInV2/RESET_STATE')
    next()
  }
}
</script>
<style>
.ivu-input-with-suffix {
  height: 34px !important;
}
</style>